import { useEffect, useState } from "react";
import Shell from "../../components/Shell";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";

const EMPTY = { title: "", body: "", is_active: true };

export default function AdminPromotions() {
    const [list, setList] = useState([]);
    const [editing, setEditing] = useState(null);

    const reload = async () => { const { data } = await api.get("/admin/promotions"); setList(data || []); };
    useEffect(() => { reload(); }, []);

    const save = async () => {
        try {
            if (editing.id) await api.put(`/admin/promotions/${editing.id}`, editing);
            else await api.post("/admin/promotions", editing);
            toast.success("Saved");
            setEditing(null); reload();
        } catch (err) { toast.error(formatApiError(err)); }
    };
    const del = async (id) => {
        if (!window.confirm("Delete promotion?")) return;
        await api.delete(`/admin/promotions/${id}`);
        toast.success("Deleted"); reload();
    };

    return (
        <Shell variant="admin">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-10 animate-fade-in">
                <div className="flex items-baseline justify-between mb-8">
                    <div><p className="eyebrow mb-2">Marketing</p><h1 className="font-heading text-3xl sm:text-4xl font-light tracking-tight">Promotions</h1></div>
                    <button data-testid="new-promo-btn" onClick={() => setEditing(EMPTY)} className="btn-primary"><Plus size={14} strokeWidth={1.5} /> New promotion</button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="promotions-list">
                    {list.map(p => (
                        <div key={p.id} className="card-base p-6">
                            <div className="flex items-start justify-between mb-2">
                                <p className="eyebrow">{p.is_active ? "Active" : "Inactive"}</p>
                                <div className="flex gap-1">
                                    <button data-testid={`promo-edit-${p.id}`} onClick={() => setEditing(p)} className="btn-ghost"><Pencil size={14} strokeWidth={1.5} /></button>
                                    <button data-testid={`promo-delete-${p.id}`} onClick={() => del(p.id)} className="btn-ghost text-red-700"><Trash2 size={14} strokeWidth={1.5} /></button>
                                </div>
                            </div>
                            <h3 className="font-heading text-lg mb-2">{p.title}</h3>
                            <p className="text-sm text-zinc-600">{p.body}</p>
                        </div>
                    ))}
                    {list.length === 0 && <div className="md:col-span-2 text-center p-12 border border-dashed border-zinc-200 rounded-sm text-sm text-zinc-500">No promotions yet.</div>}
                </div>
            </div>

            {editing && (
                <div className="fixed inset-0 z-50 bg-black/40 flex justify-end" onClick={() => setEditing(null)}>
                    <div className="bg-white w-full max-w-lg h-full overflow-y-auto p-8" onClick={(e) => e.stopPropagation()}>
                        <p className="eyebrow mb-1">{editing.id ? "Edit promotion" : "New promotion"}</p>
                        <h2 className="font-heading text-2xl mb-6">{editing.title || "Untitled"}</h2>
                        <div className="space-y-4">
                            <div><label className="input-label">Title</label><input data-testid="promo-title" className="input-base" value={editing.title} onChange={(e) => setEditing({ ...editing, title: e.target.value })} /></div>
                            <div><label className="input-label">Body</label><textarea data-testid="promo-body" rows={6} className="input-base" value={editing.body} onChange={(e) => setEditing({ ...editing, body: e.target.value })} /></div>
                            <label className="flex items-center gap-2 text-sm"><input data-testid="promo-active" type="checkbox" checked={editing.is_active} onChange={(e) => setEditing({ ...editing, is_active: e.target.checked })} /> Visible to clinics</label>
                        </div>
                        <div className="flex gap-3 mt-8 pt-6 border-t border-zinc-200">
                            <button data-testid="promo-save" onClick={save} className="btn-primary">Save</button>
                            <button onClick={() => setEditing(null)} className="btn-ghost ml-auto">Cancel</button>
                        </div>
                    </div>
                </div>
            )}
        </Shell>
    );
}
